
import axios from 'axios'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {getQueryVariable, isApp, isWeiXin, OpenApp, system} from '@/util/const'
import {urls} from '@/util/urls'

export default {
name: 'FPS',
directives: {
TransferDom
},
data() {
return {
qrCodeUrl: '',
amount: 0,
timer: null,
isWeiXin: isWeiXin(),
isIos: system(),
time: 120,
timeOut: false,
mask: false,
tipBox: false,
tipBox2: false,
warnMask: false,
form: null
}
},
methods: {

alert() {
this.timeOut = true
this.warnMask = true
},

openBox() {
this.mask = true
this.tipBox = true
},

openBox2() {
this.mask = true
this.tipBox2 = true
},

close() {
this.mask = false
this.tipBox = false
this.tipBox2 = false
},

clickRate(umvalue, form) {
let time = new Date().getTime()
let params = {
'body': {
'records': [{
'clickTime': time,
'umkey': form + '-' + umvalue
}]
},
'header': {
'msgid': '1539238964679',
'systemtime': time,
'version': '5.0.3.10'
}
}
this.$http.post('ad/clickRate-Web', params, true, {noLoading: true}).then(res => {
console.log(res)
})
},

open(link, umkey) {
const sys = system()
this.clickRate(umkey, sys)
if (isApp()) {
window.location.href = link
} else {
if (this.isIos === 'ios') {
OpenApp(link)
} else {
OpenApp(link)
}
}
},

paySuccess() {
this.$http.post('/v1/api/business_alliance/order/brandMonth')
if (getQueryVariable('txnDetails2') && getQueryVariable('txnDetails2') === 'pointstore' && getQueryVariable('cmhsOrderNo')) {
this.jumpFnc(1)
} else {
let url = `cmcchkhsh://payBillResult?
accountType=${getQueryVariable('accountType')}&
status=${getQueryVariable('status')}&
amount=${getQueryVariable('amount')}&
payMethodName=${getQueryVariable('payMethodName')}&
cpnRefCode=${getQueryVariable('cpnRefCode')}&
cpnAmount=${getQueryVariable('cpnAmount')}&
myLinkPoint=${getQueryVariable('myLinkPoint')}&
lang=${getQueryVariable('lang')}`
this.open(url)
}
},

payFail() {
this.warnMask = true
/* 如果是混分用FPS失敗成功要跳回杭研的結果頁然後返回"我的訂單" */
if (getQueryVariable('txnDetails2') && getQueryVariable('txnDetails2') === 'pointstore' && getQueryVariable('cmhsOrderNo')) {
this.jumpFnc(0)
} else {
let url = `cmcchkhsh://payBillResult?
accountType=${getQueryVariable('accountType')}&
status=-1&
amount=${getQueryVariable('amount')}&
payMethodName=${getQueryVariable('payMethodName')}&
cpnRefCode=${getQueryVariable('cpnRefCode')}&
cpnAmount=${getQueryVariable('cpnAmount')}&
myLinkPoint=${getQueryVariable('myLinkPoint')}&
lang=${getQueryVariable('lang')}`
this.open(url)
}
},

getPayInfo() {
/* 轮询支付是否成功接口 */
axios.defaults.baseURL = ''
this.$http.FPS_POST('/boss/mylink/api/service/payment/v1/check', {params:{orderRef: getQueryVariable('orderRef')}}, true).then((res) => {
if (res.returnCode == 0) {
if (res.data[0].paymentStatus === 'SUCCESS') {
this.time = 0
clearInterval(this.timer)
this.timer = null
this.timeOut = true
this.paySuccess()
}
}
})
},
/* 计时器 */
polling() {
let that = this
this.timer = setInterval(() => {
if (that.timeOut) return;
that.time--
if (that.time <= 0) {
that.timeOut = true
clearInterval(that.timer)
that.time = 0
that.timer = null
that.alert()
return
} else {
/* 轮询支付是否成功接口 */
axios.defaults.baseURL = ''
that.$http.FPS_POST('/boss/mylink/api/service/payment/v1/check', {params:{orderRef: getQueryVariable('orderRef')}}, true).then((res) => {
if (res.returnCode == 0) {
if (res.data[0].paymentStatus === 'SUCCESS') {
that.time = 0
clearInterval(that.timer)
that.timer = null
that.timeOut = true
that.paySuccess()
}
}
})
}
}, 1000)

},

visibilityChange() {
let changeState, visibilityChange, hiddenTime, visibleTime;

if (typeof document.hidden !== 'undefined') {
visibilityChange = 'visibilitychange';
changeState = 'visibilityState';
} else if (typeof document.mozHidden !== 'undefined') {
visibilityChange = 'mozvisibilitychange';
changeState = 'mozVisibilityState';
} else if (typeof document.msHidden !== 'undefined') {
visibilityChange = 'msvisibilitychange';
changeState = 'msVisibilityState';
} else if (typeof document.webkitHidden !== 'undefined') {
visibilityChange = 'webkitvisibilitychange';
changeState = 'webkitVisibilityState';
}
document.addEventListener(visibilityChange, () => {
if (document[changeState] === 'hidden') {
hiddenTime = Date.parse(new Date())
}

if (document[changeState] === 'visible') {
visibleTime = Date.parse(new Date())

let s = (visibleTime - hiddenTime) / 1000
this.time = this.time >= s ? this.time - s : 0
console.log('离开时间--', s)
if (this.time === 0) {
console.log('最后一次请求')
this.$http.FPS_POST('/boss/mylink/api/service/payment/v1/check', {params:{orderRef: getQueryVariable('orderRef')}}, true).then((res) => {
if (res.returnCode == 0) {
if (res.data[0].paymentStatus === 'SUCCESS') {
this.timeOut = true
this.paySuccess()
} else {
this.alert()
}
}
})
}
}
})
},
/* 跳转 */
jumpFnc(status = 0) {
if (status === 1) {
let param = {orderNo: this.form.cmhsOrderNo}
this.$http.post(urls.BUSINESS_ORDER_REDEEM, param)
this.$http.get(urls.BUSINESS_ORDER_END, param).then(res => {
if (res.data.header.resultCode === 0) {
window.location.href = `${window.location.origin}/mylink/#/integral/result?status=1`
/*this.$router.replace({
path: '/integral/result',
query: {
productDesc: encodeURIComponent(this.form.cusName),
status: 1
}
})*/
}
})
} else {
window.location.href = `${window.location.origin}/mylink/#/integral/result`
/*this.$router.replace({
path: '/integral/result'
})*/
}
}
},
async created() {
const data = {
'billNo': getQueryVariable('billNo'),
'billTp': getQueryVariable('billTp'),
'billTp2': getQueryVariable('billTp2'),
'txnAmtEditAble': getQueryVariable('txnAmtEditAble'),
'txnCur': getQueryVariable('txnCur'),
'isIncludeActiveTime': getQueryVariable('isIncludeActiveTime'),
'cusName': getQueryVariable('cusName'),
'amount': getQueryVariable('amount'),
'txnDetails1': getQueryVariable('txnDetails1'),
'txnDetails2': getQueryVariable('txnDetails2')
}
this.form = data
this.form.cmhsOrderNo = getQueryVariable('cmhsOrderNo')
this.amount = data.amount
axios.defaults.baseURL = ''
let res = await this.$http.FPS_POST('/ticket_racing/fps/QRCode', data, true)
if (res.header.resultCode === 0) this.qrCodeUrl = `http://47.75.61.114/v1/api/eas/pub/pic/Qrcode?code=${res.body.code}&width=500&height=500`
/* 执行计时器 */
this.polling()
this.visibilityChange()
},
}



// WEBPACK FOOTER //
// ./src/page/FPS/FPSTesting.vue